module.exports = __webpack_public_path__ + "img/generali.9e0fc154.png";